import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "check bg-primary-blue rounded-circle text-primary-white d-flex justify-content-center align-items-center" }

import CheckIcon from '@/assets/CheckIcon.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'CheckMark',
  setup(__props) {

  // Icons
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CheckIcon)
  ]))
}
}

})